import "./spinner.css";
export const Spinner = ({ color = "#0482f0", size = 32 }) => {
    return (
        <div className="spinner-container">
        <div class="spinner"></div>
      </div>
    );
  };
  